<template>
  <a-modal
    :title="$t('base.settingPhone')"
    :width="400"
    :visible.sync="userVisible"
    :bodyStyle="{ paddingBottom:0, paddingTop: '20px'}"
    @cancel="closeSettingUserNameModal"
    @ok="handleOkAddUser"
  >
    <div class="contentAddUserClass">
      <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
        <a-form-model-item prop="phoneNumber" :label="$t('base.originalPhone')">
          <a-input
            v-model="form.phoneNumber"
            allow-clear
            autocomplete="new-password"
            hide-button
            :disabled="loading"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item prop="newPhoneNumber" :label="$t('base.newPhone')">
          <a-input
            v-model="form.newPhoneNumber"
            allow-clear
            autocomplete="new-password"
            :maxlength="6"
            hide-button
            :disabled="loading"
          ></a-input>
        </a-form-model-item>

        <a-form-model-item prop="code" style="margin-top: 10px" :label="$t('base.pleaseInputCode')">
          <a-input class="codeInput" v-model="form.code" allow-clear hide-button :disabled="loading">
            <template #suffix>
              <div
                class="send-code"
                :class="{ disabled: isCountingDown || loading }"
                v-if="!isCountingDown"
                @click="sendCode"
              >
                {{$t('base.getCode')}}
              </div>
              <div v-else style="width: 100%; height: 100%; font-size: 14px; color: #a2a5ae">
                {{ countdown }} {{$t('base.afterSecondResend')}}

              </div>
            </template>
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { Modal } from '@/components'
import { getUserUpdate, sendCaptchaLogin } from '@/api/user.js'
export default {
  name: 'addUserModal',
  props: {
    userId: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      countdown: 0,
      loading: false,
      isSendCode: false, //是否发过验证码
      userVisible: true,
      form: {
        phoneNumber: this.phone,
        newPhoneNumber: '',
        code: '',
      }
    }
  },
  computed: {
    isCountingDown() {
      return this.countdown > 0 || false
    },
    rules() {
      return {
        phoneNumber: [
          { required: true, message: this.$t('base.phoneNotEmpty'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        newPhoneNumber: [
          { required: true, message: this.$t('base.phoneNotEmpty'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('base.codeNotEmpty'), trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '请输入6位数字验证码', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {},
  methods: {
    // 获取验证码
    async sendCode() {
      this.isSendCode = true
      try {
        // 先验证手机号
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(this.form.phoneNumber)) {
          this.$message.warning('请输入正确的手机号！')
          return
        }
        this.loading = true
        const res = await sendCaptchaLogin(this.form.phoneNumber)
        if (res.code === 200) {
          this.$message.success('验证码发送成功！')
          this.startCountdown()
        } else {
          this.$message.error(res.message || '验证码发送失败！')
        }
      } catch (error) {
        // this.$message.error('发送验证码失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    // 启动倒计时
    startCountdown() {
      const TIME_COUNT = 60
      this.countdown = TIME_COUNT
      const interval = setInterval(() => {
        if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
          this.countdown -= 1
        } else {
          clearInterval(interval)
        }
      }, 1000)
    },
    // 验证手机号
    validatePhone(rule, value, callback) {
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t('base.phoneNumberError')))
      } else {
        callback()
      }
    },
    // 关闭
    closeSettingUserNameModal() {
      this.$emit('closeSettingPhoneModal')
    },
    // 确认
    async handleOkAddUser() {
      try {
        // 表单验证
        await this.$refs.loginForm.validate()

        if (!this.isSendCode) {
          this.$message.error('请先获取验证码')
          return
        }
        this.loading = true
        const data = {
          newPhone: this.form.newPhoneNumber,
          code: this.form.code,
          account: this.userId,
        }
        // 调用验证码登录接口
        const loginRes = await getUserUpdate(data)
        if (loginRes.code === 200) {
          this.$message.success('修改成功！')
          this.$emit('refreshDetail')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.login-form {
  font-size: 18px;
  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input {
    width: 360px;
    height: 40px;
    background-color: #222222;
    // border: none;
    border-radius: 8px;

    &:focus {
      box-shadow: none;
    }
  }

  /deep/.ant-select-selector {
    background-color: #222222 !important;
    border: none !important;
    border-radius: 8px !important;
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  bottom: 10px;
  padding: 0px 5px;

  .register-link {
    color: #0166fc;
    cursor: pointer;
  }
}

.codeInput {
  /deep/.anticon-close-circle {
    margin-right: 5px;
  }
}

.send-code {
  cursor: pointer;
  color: #0166fc;
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
